document.addEventListener("DOMContentLoaded", () => {

    const images = Array.from(document.querySelectorAll(".imagen-contenido-multimedia"));
    const prevBtn = document.querySelector(".flecha-anterior-multimedia");
    const nextBtn = document.querySelector(".flecha-siguiente-multimedia");
    const filterBtns = document.querySelectorAll(".contenedor-navegador-nombre-multimedia");

    let index = 0;
    let activeSlides = [...images];
    const mediaQuery = window.matchMedia("(max-width: 1000px)");

    // 🔥 cambia imágenes según device
    function updateImagesByDevice() {
        images.forEach(img => {
            const desktop = img.dataset.desktop;
            const mobile = img.dataset.mobile;
            img.src = mediaQuery.matches ? mobile : desktop;
        });
    }

    // 🔥 muestra slide activo
    function showSlide(i) {
        activeSlides.forEach(img => img.classList.remove("active"));

        if (activeSlides.length === 0) return;

        if (i >= activeSlides.length) index = 0;
        if (i < 0) index = activeSlides.length - 1;

        activeSlides[index].classList.add("active");
    }

    function nextSlide() {
        index = (index + 1) % activeSlides.length;
        showSlide(index);
    }

    function prevSlide() {
        index = (index - 1 + activeSlides.length) % activeSlides.length;
        showSlide(index);
    }

    let interval = setInterval(nextSlide, 5000);

    function resetInterval() {
        clearInterval(interval);
        interval = setInterval(nextSlide, 5000);
    }

    // 🔥 FILTRO POR BOTONES
    function setFilter(filter) {

        // normaliza texto
        const value = filter.toLowerCase().trim();

        activeSlides = images.filter(img => {
            const alt = (img.alt || "").toLowerCase();
            return alt.includes(value);
        });

        index = 0;

        // reset estado visual
        images.forEach(img => img.classList.remove("active"));

        if (activeSlides.length > 0) {
            activeSlides[0].classList.add("active");
        }
    }

    // botones filtro
    filterBtns.forEach(btn => {
        btn.addEventListener("click", () => {
            setFilter(btn.textContent);
            resetInterval();
        });
    });

    // flechas
    if (nextBtn) {
        nextBtn.addEventListener("click", () => {
            nextSlide();
            resetInterval();
        });
    }

    if (prevBtn) {
        prevBtn.addEventListener("click", () => {
            prevSlide();
            resetInterval();
        });
    }

    // responsive images
    mediaQuery.addEventListener("change", updateImagesByDevice);

    // init
    updateImagesByDevice();

    // activa primer slide
    if (images.length > 0) {
        activeSlides = images;
        showSlide(0);
    }

});
let slideActual = 0;
// Asegúrate de que las clases de tus imágenes coincidan con '.imagen-contenido-multimedia'
const slides = document.querySelectorAll('.imagen-contenido-multimedia');
const itemsNav = document.querySelectorAll('.contenedor-navegador-item');
const barras = document.querySelectorAll('.barra-progreso-llena');

let tiempoTotal = 5000; // Duración en milisegundos (5 segundos)
let frameRequest;
let inicioTiempo;
let pausado = false;

function actualizarUI() {
    slides.forEach((s, i) => s.classList.toggle('active', i === slideActual));
    itemsNav.forEach((n, i) => n.classList.toggle('active', i === slideActual));
    barras.forEach(b => b.style.width = '0%');
}

function animarBarra() {
    if (pausado) return;
    
    const ahora = Date.now();
    const transcurrido = ahora - inicioTiempo;
    const progreso = (transcurrido / tiempoTotal) * 100;

    if (progreso <= 100) {
        if (barras[slideActual]) {
            barras[slideActual].style.width = progreso + '%';
        }
        frameRequest = requestAnimationFrame(animarBarra);
    } else {
        cambiarSlide(1);
    }
}

function iniciarCiclo() {
    cancelAnimationFrame(frameRequest);
    inicioTiempo = Date.now();
    animarBarra();
}

function cambiarSlide(direccion) {
    if (slides.length === 0) return;
    slideActual = (slideActual + direccion + slides.length) % slides.length;
    actualizarUI();
    iniciarCiclo();
}

function irASlide(indice) {
    slideActual = indice;
    actualizarUI();
    iniciarCiclo();
}

// Opcional: Si quieres que el tiempo continúe al quitar el cursor
function pausarProgreso() {
    pausado = true;
    cancelAnimationFrame(frameRequest);
}

function reanudarProgreso() {
    pausado = false;
    const anchoActual = parseFloat(barras[slideActual].style.width) || 0;
    inicioTiempo = Date.now() - (anchoActual * tiempoTotal / 100);
    animarBarra();
}

// Inicialización automática
document.addEventListener("DOMContentLoaded", () => {
    if(barras.length > 0) iniciarCiclo();
});